import React, { Component } from "react";
import "./styles.css";
//import G from "../../../js/globals";
import E from "../../../js/events";


import Divider        from "../../prefabs/divider/view";
import Icon           from "../../prefabs/icon/view";
import FloatingArrows from "../../widgets/floating-arrows/view";

// import imgChar        from "./img/cake_c.png";
import BirthdayExtra  from "./birthday-extra";
import BirthdayItem   from "./birthday-item";





class SectionIntro extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.addChildToList      = this.addChildToList.bind(this);
    this.removeChildfromList = this.removeChildfromList.bind(this);

    this.handleModifyStar    = this.handleModifyStar.bind(this);
    this.handleEditingStar   = this.handleEditingStar.bind(this);

    this.onClickAddBtn       = this.onClickAddBtn.bind(this);
    this.onClickDetailsBtn   = this.onClickDetailsBtn.bind(this);

    this.state = {
      isEditing: false,
    };



    this.addBtnAvailable = false;
    this.addBtnHidden    = false;
  }



  // ===============================================================================================
  addChildToList(child) {
    // console.log("INTRO:\n Adding child to list", child);
    this.props.handleAppEvent(E.events.INTRO_ADD_CHILD, child);
  }



  // ===============================================================================================
  removeChildfromList(child) {
    // console.log("INTRO:\n Removing child from list", child);
    this.props.handleAppEvent(E.events.INTRO_REM_CHILD, child);
  }



  // ===============================================================================================
  handleModifyStar(child) {
    // console.log("INTRO:\n Modifying child in list", child);
    this.props.handleAppEvent(E.events.INTRO_MOD_CHILD, child);
  }



  // ===============================================================================================
  handleEditingStar(isEditing) {
    // console.log("INTRO:\n Is editing: ", isEditing);
    this.setState({ isEditing: isEditing });
  }



  // ===============================================================================================
  onClickAddBtn(e) {
    e.preventDefault();
    // console.log("INTRO:\n Clicked add button");
    if (this.addBtnAvailable) {
      this.addChildToList({ name: "", age: "" });
    }
  }



  // ===============================================================================================
  onClickDetailsBtn(e) {
    e.preventDefault();
    // console.log("INTRO:\n Clicked details button");
  }



  // ===============================================================================================
  render() {
    // ---------------------------------------------------------------------------------------------
    // Get the current "star" (last child in starlist)
    let lastStar        = null;
    let lastStarSection = null;
    let starList        = null;
    let starListSection = null;
    let birthdaysHint = {
      "hosted": "Add the birthday child's name and hit enter.<br/>Press plus if you are celebrating more than one child's birthday.",
      "no-host": "Add the name of the event host or group and hit enter."
    };
    let birthdaysSubtitle = {
      "hosted": "Birthday Party!",
      "no-host": "Event!"
    };

    // console.log("EVENT TYPE:", this.props.eventType);
    // console.log("BIRTHDAYS HINT:", birthdaysHint[this.props.eventType]);

    if (this.props.starList && this.props.starList.length > 0) {
      lastStar = this.props.starList[0];

      if (this.props.starList.length > 1) {
        lastStar = this.props.starList[this.props.starList.length-1];
      }

      lastStarSection = (
        <BirthdayItem
          eventType={     this.props.eventType   }
          id={            lastStar.id            }
          name={          lastStar.name          }
          age={           lastStar.age           }
          handleChange={  this.handleModifyStar  }
          handleEditing={ this.handleEditingStar }
        />
      );



      // Generate list of stars
      starList = this.props.starList.map((item) => (
        <BirthdayExtra key={item.id}
          eventType={   this.props.eventType     }
          id={          item.id                  }
          name={        item.name                }
          age={         item.age                 }
          hidden={      item.id === lastStar.id  }
          handleClick={ this.removeChildfromList }
        />
      ));

      starListSection = (
        <div className="birthdays__starlist">
          {starList}
        </div>
      );
    }



    // ---------------------------------------------------------------------------------------------
    // Check if the add button is available (only when starchild is filled in)
    this.addBtnAvailable = false;

    
    if (lastStar !== null && lastStar.name !== "" && this.props.starList.length < 5) {
      if (this.props.eventType === 'hosted' && lastStar.age !== "") {
        this.addBtnAvailable = true;
      } else if (this.props.eventType === 'no-host') {
        this.addBtnAvailable = true;
      }
    }



    // ---------------------------------------------------------------------------------------------
    // Check if the add button should be hidden (while something is being edited)
    this.addBtnHidden = false;

    if (this.state.isEditing || this.props.starList.length >= 5) {
      this.addBtnHidden = true;
    }



    // ---------------------------------------------------------------------------------------------
    return (
      <div className="cont-section cont-section--offset-header cont-section--intro">
        <div className="cont-wrapper">



          {/* <Divider type="coloured-dots" className="divider--top"/> */}



          <div className="birthdays">
            <div className="title-smile">
              <img className="title-smile-img" src="https://mcdonalds.com.au/sites/mcdonalds.com.au/files/smile.svg"  alt="smile"/>
            </div>
            <div className="birthdays__title bold-text">
              <img className="title-img" src="https://mcdonalds.com.au/sites/mcdonalds.com.au/files/lets-celebrate.svg"  alt="Let's celebrate"/>
              {/* <strong> Let's celebrate </strong> */}
            </div>

            {starListSection}

            <div className="birthdays__starchild">

              <button className={"add-btn" +
                ((!this.addBtnAvailable) ? " add-btn--disabled" : "") +
                (( this.addBtnHidden)    ? " add-btn--hidden"   : "")}
                tabIndex="-1"
                onClick={this.onClickAddBtn}>
                <Icon type="add" />
              </button>

              {lastStarSection}

              <div className="birthdays__starchild__divider">
                <Divider type="dotted-yellow" />
              </div>

            </div>

            <div className="birthdays__hint">
                  <div dangerouslySetInnerHTML={{ __html: birthdaysHint[this.props.eventType] }} />
            </div>

            <div className="birthdays__subtitle">
              {birthdaysSubtitle[this.props.eventType]}
            </div>

          </div>



          {/* <Divider type="coloured-dots" className="divider--bot"/> */}



          {/*<img className="character-img" src={imgChar} alt=""/>*/}
          {/* <img className="character-img" src="./img/partiesnew-min.png" crossorigin="anonymous"  alt="Maccas parties"/> */}
          {/* <img className="character-img" src="https://mcdonalds.com.au/sites/mcdonalds.com.au/files/mc-parties.png"  alt="Maccas parties"/> */}



          <FloatingArrows
            handleChange={  this.props.handleChange                                                   }
            items={        this.props.items                                                           }
            hidden={      (this.props.activeSlideId !== 'intro' && this.props.activeSlideId !== 'eventType') ? true : false }
            activeSlide={  this.props.activeSlide                                                 }
          />



        </div>
      </div>
    );
  }

}



export default SectionIntro
